<template>
    <div>
        <div class="panel">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item,index) in info.img_list" :key="index">
                    <img class="img-style" :src="item.url" />
                </van-swipe-item>
            </van-swipe>
            <div class="price-banner">
                <div class="left-price">
                    <span class="price-code">￥</span>
                    <span class="price">{{info.group_price}}</span>
                    <span class="price-origin">￥{{info.origin_price}}</span>
                </div>
                <div class="commission" v-if="current_mode==1">
                    <span class="label">佣金</span>
                    <span class="value">￥{{info.commission}}</span>
                </div>
                <div class="count-down" v-if="showCountDown">
                    <span>
                        <van-count-down :time="countDownTime" format="DD天HH时mm分ss秒" />
                    </span>
                </div>
            </div>
            <div class="name-banner">
                <span>{{info.product_name}}</span>
            </div>
        </div>

        <!--动态属性-->
        <div class="panel-attr" v-if="info.arr_list.length>0">
            <van-row v-for="(item,index) in info.arr_list" :key="index">
                <van-col span="4" class="label">{{item.name}}</van-col>
                <van-col span="16" class="text">{{item.attr_value}}</van-col>
                <van-col span="4" class="right" v-if="item.name=='地址'">
                    <a href="https://uri.amap.com/marker?position=119.822309,30.333986&name=梅唐四季果园">导航</a>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    export default {
        name: "ProductPartOneGroup",
        props:{
            rule_id:{           //拼团配置id
                type:String,
                default:'',
                required:false,
            },
            mode:{              //模式：1合伙人模式；2终端客户模式
                type:String,
                default:'1',
                required:false,
            },
            showCountDown:{     //是否显示倒计时
                type:Boolean,
                default:false,
                required:false
            },
        },
        data(){
            return {
                current_mode:this.mode,
                info:{
                    img_list:[],
                    arr_list:[],
                },
                countDownTime: 0,
            }
        },
        methods:{
            ...mapActions([
                'GetSaleToolGroupRuleInfo',
            ]),
            loadData(){
                let rule_id=this.rule_id;
                this.GetSaleToolGroupRuleInfo({rule_id}).then(res=>{
                    this.info=res;
                    let now_time = parseInt(new Date().getTime());
                    this.countDownTime=parseInt(res.end_time)*1000 - now_time;
                })
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
    .panel{
        background-color: #FFFFFF;
    }
    .img-style{
        max-height: 500px;
        width: 100%;
        margin-top: 0;
    }
    .price-banner{
        width: 100%;
        padding-top: 3px;
        min-height: 40px;
        .left-price{
            display: inline-block;
            float: left;
            padding-left: 5px;
            .price-code{
                font-size: 12px;
                color: #E34928;
            }
            .price{
                font-size: 20px;
                font-weight: bold;
                color: #E34928;
            }
            .price-origin{
                font-size: 12px;
                text-decoration:line-through;
                color: #666666;
                padding-left: 3px;
            }
        }
        .commission{
            display: inline-block;
            float: right;
            margin-top:3px;
            margin-right: 10px;
            border: 1px solid #E34928;
            border-radius: 3px;
            font-size: 12px;
            width: 80px;
            text-align: center;
            .label{
                display: inline-block;
                color: #E34928;
                width: 35px;
            }
            .value{
                display: inline-block;
                background-color: #E34928;
                color: #ffffff;
                font-weight: bold;
                width: 45px;

            }
        }
        .count-down{
            display: inline-block;
            float: right;
            margin-top:3px;
            margin-right: 5px;
            font-size: 12px;
            color: #999999;
            text-align: center;
        }
    }
    .name-banner{
        width: 100%;
        min-height: 30px;
        text-align: left;
        font-size: 16px;
    }
    .panel-attr{
        background-color: #FFFFFF;
        margin-top: 4px;
        min-height: 30px;
        padding-top: 8px;
        .label{
            color:#666666;
            font-size: 12px;
        }
        .text{
            text-align: left;
            color: #444444;
            font-size: 14px;
        }
        .right{
            text-align: right;
            font-size: 14px;
            padding-right: 14px;
            a{
                color: #666666;
            }
        }
    }

</style>
